import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCameraOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"camera-off"} maskId="square-filled-radius-0-stroke-1-IconCameraOff"><path fillRule="evenodd" clipRule="evenodd" d="M9.23241 3L7.23241 6H2V21H22V6H16.7676L14.7676 3H9.23241ZM9.74829 10.5429L12 12.7946L14.2517 10.5429L14.9588 11.25L12.7071 13.5017L14.9571 15.7517L14.25 16.4588L12 14.2088L9.75 16.4588L9.04289 15.7517L11.2929 13.5017L9.04118 11.25L9.74829 10.5429Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCameraOff;
